/**
 * Role Utilities
 * Provides role normalization and mapping functions
 */

/**
 * Role mapping - maps various role names to standard roles
 */
export const userRoles = {
  'admin': 'admin',
  'administrator': 'admin',
  '管理員': 'admin',
  '系統管理員': 'admin',
  'super_admin': 'admin',
  'superadmin': 'admin',
  'teacher': 'teacher',
  '教師': 'teacher',
  '老師': 'teacher',
  'student': 'student',
  '學生': 'student',
  'parent': 'parent',
  '家長': 'parent',
  'staff': 'staff',
  '職員': 'staff',
  '職工': 'staff'
};

/**
 * Normalize user role
 * Maps various role names to standard role values
 * @param {string} role - Role to normalize
 * @returns {string} Normalized role
 */
export const normalizeRole = (role) => {
  if (!role) return 'student'; // Default role
  
  const normalized = role.toLowerCase().trim();
  
  // Check direct mapping
  if (userRoles[normalized]) {
    return userRoles[normalized];
  }
  
  // Check case-insensitive mapping
  const roleKey = Object.keys(userRoles).find(
    key => key.toLowerCase() === normalized
  );
  
  if (roleKey) {
    return userRoles[roleKey];
  }
  
  // Return original role if no mapping found
  return role;
};

/**
 * Check if role is admin (any admin variant)
 * @param {string} role - Role to check
 * @returns {boolean}
 */
export const isAdminRole = (role) => {
  return normalizeRole(role) === 'admin';
};

/**
 * Get all admin role variants
 * @returns {Array<string>} Array of admin role names
 */
export const getAdminRoleVariants = () => {
  return Object.keys(userRoles).filter(key => userRoles[key] === 'admin');
};

